import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { configSelector } from "ccui-framework";
import { Helmet } from "react-helmet";
import { HeadLine } from "../modules/HeadLine";
import { ClearCart, CreateCard, createCart, ViewCards } from "../modules/Card";
import {
  UploadSpreadSheetButton,
  UploadSpreadSheetComponent,
} from "../modules/SSUploader";
import { OrderPaymentOptions } from "../modules/PaymentMethods";
import { MAG, magCard } from "../modules/MagSensor";

const Container = styled.div`
  flex: 80%;
  padding: 2rem;
`;

const InputBox = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border: 1px dashed rgba(100, 100, 100, 0.03);
  padding: 1.5rem 2rem;
  margin: 2rem 0px;
  box-shadow: 0 1.25px 2.5px -1.25px rgba(100, 100, 100, 1);
  border-radius: 0.3rem;
  transition: box-shadow 0.5s ease 0s, border 0.5s ease 0s,
    background-color 0.5s ease 0s, transform 0.5s ease 0s;
  transform: translate(0%, 0%);

  &:active,
  &:hover {
    background-color: rgba(100, 100, 100, 0.03);
    border: 1px solid rgba(100, 100, 100, 0.5);
    box-shadow: 0 10px 20px -10px rgba(100, 100, 100, 1);
    transition: box-shadow 0.5s ease 0s, border 0.5s ease 0s,
      background-color 0.5s ease 0s, transform 0.5s ease 0s;
    transform: translate(0%, -1%);
  }
`;

const Form = styled.div`
  flex: 1 1 0%;
`;

const Actions = styled.div`
  display: flex;
  margin: 0px 0px 1.5rem;
  justify-content: end;
  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

const CreateOrderPage = () => {
  const dispatch = useDispatch();
  const { brand } = useSelector(configSelector);
  const { card } = useSelector(magCard);

  useEffect(() => {
    dispatch(createCart());
  }, []);

  return (
    <Container>
      <Helmet>
        <title>Sell Gift Cards for Cash Online | {brand}</title>
      </Helmet>

      <HeadLine headingText={"Sell Cards"} />

      <MAG />
      <UploadSpreadSheetComponent />

      <InputBox>
        <Form>
          <CreateCard idx={"uploader[0]"} enteredCard={card} />
        </Form>
      </InputBox>

      <Actions>
        <ClearCart />
        <UploadSpreadSheetButton />
      </Actions>

      <ViewCards>
        <OrderPaymentOptions />
      </ViewCards>
    </Container>
  );
};

CreateOrderPage.propTypes = {};

export default CreateOrderPage;
